module.exports = __webpack_public_path__ + "static/media/4Google_Nasa_sAccessMars.0492b3e7.JPG";